import { FEEDBACK_SUBMISSION_SUMMARY } from '../../constants/CopilotInAppActionTypes';
export const feedbackSubmissionSummary = action => ({
  data: {
    intent: FEEDBACK_SUBMISSION_SUMMARY,
    property_filters: action.property_filters,
    context: action.context
  },
  text: action.text
});